import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import type { PropertyDetailDTO, PropertyFormData } from '../../types';

export function useGetPropertyById(id: string, options?: { enabled?: boolean }) {
	const forBinding = useForBindingId();
	return useQuery({
		queryKey: ['propertyId', id, forBinding],
		enabled: options?.enabled,
		queryFn: async () => (await api.get<PropertyDetailDTO>(`/user/prop/get/${id}`, { params: { forBinding } })).data,
		select: (data) => {
			if (!data) return null;
			const { name, subscription, state, cep, address, avatar, totalAreas } = data;

			return {
				property: {
					...data,
					address: address ?? {},
					city: address?.city ?? '',
					totalAreas: totalAreas ?? data.areas.length,
					totalSectors: data.totalSectors ?? data.areas.reduce((total, area) => total + area.sectors.length, 0),
				},
				formData: {
					name,
					subscription: subscription ?? '',
					state,
					cep: cep ?? '',
					city: address?.city ?? '',
					street: address?.street ?? '',
					district: address?.district ?? '',
					number: address?.number ?? '',
				} as PropertyFormData,
				avatarUrl: avatar?.url,
				totalAreas: totalAreas ?? data.areas.length,
			};
		},
	});
}
